export default __webpack_public_path__ + "static/media/arrowdown.b9384d88.svg";